import  { jwtServerInstance }  from '../index'
import {getTokenUser} from "@/lib/utils";
import qs from	'qs'
import {encryptPassword} from "../../lib/utils";

//JWT登录认证接口
export const login = (userName,passWord, roleCode) => {
    return jwtServerInstance.request({
        url:'/authentication',
        method:'post',
        data:{
            userName: userName,
            password: encryptPassword(passWord),
            userRole: roleCode
        }
    })
}
//JWT令牌刷新接口
export const refreshToken = () => {
    return jwtServerInstance.request({
        url:'/refreshtoken',
        method:'get'
    })
}

//获取用户信息接口(个人中心)
export const getUserInfo = () => {
    return jwtServerInstance.request({
        url:'/sysuser/info',
        method:'get',
        params:{
            username: getTokenUser()
        }
    })
}

//获取用户信息接口(试客)
export const getCustomerInfo = () => {
    return jwtServerInstance.request({
        url:'/b2customer/customerinfo',
        method:'post',
        data:qs.stringify({
            userName: getTokenUser()
        })
    })
}


//=====================用户管理接口开始========================
//用户列表查询接口
export const getUsers = (queryform,pagination) => {
    //console.log(queryform)
    return jwtServerInstance.request({
        url:'/sysuser/query',
        method:'post',
        data:qs.stringify({
            orgId: queryform.orgId,
            username: queryform.username,
            phone: queryform.phone,
            email: queryform.email,
            enabled: queryform.enabled,
            createStartTime: queryform.timeRange[0],
            createEndTime: queryform.timeRange[1],
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

//更新sys_user的一条数据记录
export const updateUser = (userForm) => {
    return jwtServerInstance.request({
        url:'/sysuser/update',
        method:'post',
        data:userForm
    })
}

//新增一条sys_user数据记录
export const addUser = (userForm) => {
    return jwtServerInstance.request({
        url:'/sysuser/add',
        method:'post',
        data:userForm
    })
}

//新增一条sys_user数据记录
export const registerUser = (userForm) => {
    return jwtServerInstance.request({
        url:'/sysuser/register',
        method:'post',
        data:userForm
    })
}

export const sendSmsGetCode = (shareCode, phoneNum) =>{
    return jwtServerInstance.request({
        url:'/sysuser/sendsms',
        method:'post',
        data:qs.stringify({
            shareCode: shareCode,
            phoneNum:phoneNum
        })
    })
}

//新增忘记密码的短信发送接口
export const sendSmsForgetPwd = (phoneNum) =>{
    return jwtServerInstance.request({
        url:'/sysuser/sendsmsfwd',
        method:'post',
        data:qs.stringify({
            phoneNum:phoneNum
        })
    })
}

export const querySmsTime = () =>{
    return jwtServerInstance.request({
        url:'/sysuser/querysmstime',
        method:'post'
    })
}

export const resetPassword = (queryForm) =>{
    return jwtServerInstance.request({
        url:'/sysuser/resetpwd',
        method:'post',
        data:qs.stringify({
            phoneNum:queryForm.userName,
            roleCode: queryForm.roleCode,
            userAnswer: queryForm.userAnswer,
            passwd: queryForm.userPassword
        })
    })
}

//删除一条sys_user数据记录
export const deleteUser = (username) => {
    return jwtServerInstance.request({
        url:'/sysuser/delete',
        method:'post',
        data:qs.stringify({
            username:username
        })
    })
}

//sys_user数据记录的enabled字段
export const changeEnabled = (username,enabled) => {
    return jwtServerInstance.request({
        url:'/sysuser/enabled/change',
        method:'post',
        data:qs.stringify({
            username,
            enabled
        })
    })
}

//重置用户密码
export const resetUserPwd = (username) => {
    return jwtServerInstance.request({
        url:'/sysuser/pwd/reset',
        method:'post',
        data:qs.stringify({
            username
        })
    })
}

//判断当前用户是否仍在使用默认密码，没做修改
export const pwdIsDefault = () => {
    return jwtServerInstance.request({
        url:'/sysuser/pwd/isdefault',
        method:'post',
        data:qs.stringify({
            username:getTokenUser()
        })
    })
}


//修改密码
export const changeUserPwd = (oldPass,newPass) => {
    return jwtServerInstance.request({
        url:'/sysuser/pwd/change',
        method:'post',
        data:qs.stringify({
            username:getTokenUser(),
            oldPass:oldPass,
            newPass:newPass
        })
    })
}

//修改提现密码密码
export const changeUserCashPwd = (moneyPassword) => {
    return jwtServerInstance.request({
        url:'/b2customer/resetpassword',
        method:'post',
        data:qs.stringify({
            moneyPassword:moneyPassword
        })
    })
}

export const getRole = () => {
    return jwtServerInstance.request({
        url:'/roles',
        method:'post'
    })
}



export const getOneLever = () => {
    return jwtServerInstance.request({
        url:'/b2customer/querysharedown',
        method:'post'
    })
}


export const getTwoLever = () => {
    return jwtServerInstance.request({
        url:'/b2customer/querysharedownlever',
        method:'post'
    })
}

export const queryUserQuestion = (phoneNum) => {
    return jwtServerInstance.request({
        url:'/userfpquestion/query',
        method:'post',
        data:qs.stringify({
            phoneNumber: phoneNum
        })
    })
}

export const saveUserQuestion = (questions, answer) => {
    return jwtServerInstance.request({
        url:'/userfpquestion/add',
        method:'post',
        data:{
            userQuestion: questions,
            userAnswer: answer,
        }
    })
}
